import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkbox"
export default class extends Controller {
  connect() {
    let checkboxes = document.querySelectorAll('input[type=checkbox]');
    const checkSpan = '<span class="checkmark"></span>';
    checkboxes.forEach(box => {
      const next = box.nextSibling;
      if (!(next && next.nodeType === 1 && next.classList.contains('checkmark'))) {
        box.insertAdjacentHTML('afterend', checkSpan);
      }
    });
  }
}
